import * as type from './types';

export function markCancelProject(data) {
    return {
        type: type.POST_PROJECT_CANCEL_REQUESTED,
        data: data,
    }
}